import { useTranslation } from "react-i18next";
import * as Yup from "yup";

export const YupProgram = () => {
  //page hook
  const { t } = useTranslation();

  return {
    programName: Yup.string().required(
      t("validation.required", {
        programName: t("page.programName"),
      })
    ),
    noOfCoupons: Yup.number()
      .required(
        t("validation.required", {
          noOfCoupons: t("page.noOfCoupons"),
        })
      )
      .min(1, t("validation.min", { field: t("page.noOfCoupons"), min: 1 }))
      .integer(t("validation.integer", { field: t("page.noOfCoupons") }))
      .typeError(t("validation.number", { field: t("page.noOfCoupons") })),
  };
};
